import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import Event from 'src/app/core/models/event';
import * as moment from 'moment-timezone';

@Component({
  selector: 'twod-event-info',
  standalone: true,
  templateUrl: './event-info.component.html',
  styleUrls: ['./event-info.component.css'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventInfoComponent {
  @Input() event!: Event;
  @Input() expanded = false;
  @Output() onClose = new EventEmitter();
  @Output() onOpen = new EventEmitter();

  get date() {
    return moment(this.event.startAt)
      .tz('America/Santo_Domingo')
      .locale('es')
      .format('dddd, D [de] MMMM [de] YYYY - h:mm A');
  }

  toggle() {
    if (this.expanded) {
      this.onClose.emit();
    } else {
      this.onOpen.emit();
    }

    this.expanded = !this.expanded;
  }
}
